const WORKSPACE_PATH_RE = /^\/spaces\/([^/]+)(?:\/(.*))?$/;
const DIRECT_MESSAGE_PATH_RE = /^\/messages\/([^/]+)(\/.*)?$/;

export const workspaceRailPath = (workspace, { channelId = null } = {}) => {
  const workspaceId = String(workspace.id);
  const mainChannelId = workspace.main_channel_id ? String(workspace.main_channel_id) : null;
  const targetChannelId = channelId || mainChannelId;

  return targetChannelId ? `/spaces/${workspaceId}/chats/${targetChannelId}` : `/spaces/${workspaceId}/chats`;
};

export const searchResultRoutePath = ({ workspaceId, channelId, directMessageId = null }) => {
  if (directMessageId) return `/messages/${String(directMessageId)}/chats/${String(channelId)}`;

  return `/spaces/${String(workspaceId)}/chats/${String(channelId)}`;
};

export const parseWorkspacePath = (pathname) => {
  const match = WORKSPACE_PATH_RE.exec(pathname);
  if (!match) return null;

  const [, workspaceId, tail = ''] = match;

  return {
    workspaceId,
    base: `/spaces/${workspaceId}`,
    relativePath: tail ? `/${tail}` : '/',
  };
};

export const mainLayoutRelativePath = (pathname) => {
  const directMessageMatch = DIRECT_MESSAGE_PATH_RE.exec(pathname);
  if (directMessageMatch) return directMessageMatch[2] || '/';

  return parseWorkspacePath(pathname)?.relativePath || null;
};
